// const BASE_URL = "http://localhost:5000/api";
const BASE_URL = "https://apisbtc.gorillafishingroom.com/api";

export default BASE_URL;
